<template>
  <v-sheet width="600" class="px-16 pt-8 pb-6">
    <!-- 제목 -->
    <p class="mb-6 font-weight-bold text-center text-h5">직원 추가</p>

    <!-- 입력란 -->
    <v-sheet class="mt-2 px-4">
      <!-- 유형 -->
      <v-select class="rounded-lg mb-4" label="유형" dense outlined hide-details :items="select_list.type" v-model="type"></v-select>

      <!-- 이름 (다국어) -->
      <div class="mb-4">
        <div class="font-weight-medium mb-2">이름</div>
        <v-text-field class="rounded-lg mb-2" label="이름 (한글)" dense outlined hide-details v-model="name_kr"></v-text-field>
        <v-text-field class="rounded-lg mb-2" label="이름 (영어)" dense outlined hide-details v-model="name_en"></v-text-field>
        <v-text-field class="rounded-lg" label="이름 (일어)" dense outlined hide-details v-model="name_jp"></v-text-field>
      </div>

      <!-- 아이디 -->
      <v-text-field class="rounded-lg mb-4" label="아이디" dense outlined hide-details v-model="user_id"></v-text-field>

      <!-- 비밀번호 -->
      <v-text-field class="rounded-lg mb-4" label="비밀번호" type="password" dense outlined hide-details v-model="password"></v-text-field>

      <v-text-field class="rounded-lg mb-4" label="휴대폰번호" dense outlined hide-details v-model="phoneNumber" type="number" hide-spin-buttons></v-text-field>

      <v-select class="rounded-lg mb-6" label="지점" dense outlined hide-details :items="branchList" item-text="displayText" item-value="id" v-model="branchId" clearable></v-select>

      <div class="mb-2">
        <div class="font-weight-medium mb-2">프로필 이미지</div>
        <v-sheet outlined class="rounded-lg mb-3 profile-preview d-flex align-center justify-center">
          <v-img :src="profileImagePreviewSrc" contain height="150">
            <template v-slot:placeholder>
              <div class="grey--text text--darken-1 text-caption preview-placeholder">이미지 미리보기</div>
            </template>
          </v-img>
        </v-sheet>
        <v-sheet class="profile-dropzone mb-2" @drop.prevent="handleDrop" @dragover.prevent>
          <v-file-input class="rounded-lg" outlined dense show-size hide-details prepend-icon color="primary" label="프로필 이미지" v-model="uploadImage" accept="image/*" @change="onFileChange">
            <template v-slot:prepend-inner>
              <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
            </template>
          </v-file-input>
        </v-sheet>
        <v-btn text small color="grey darken-1" class="px-2" @click="clearProfileImage" v-if="hasProfileImage">이미지 초기화</v-btn>
      </div>

      <div class="mb-2">
        <div class="font-weight-medium mb-2">작가 소개 이미지 (1500 x 600)</div>
        <v-sheet outlined class="rounded-lg mb-3 staff-preview d-flex align-center justify-center">
          <v-img :src="staffImagePreviewSrc" contain height="240">
            <template v-slot:placeholder>
              <div class="grey--text text--darken-1 text-caption preview-placeholder">이미지 미리보기</div>
            </template>
          </v-img>
        </v-sheet>
        <v-sheet class="staff-dropzone mb-2" @drop.prevent="handleStaffDrop" @dragover.prevent>
          <v-file-input
            class="rounded-lg"
            outlined
            dense
            show-size
            hide-details
            prepend-icon
            color="primary"
            label="작가 소개 이미지"
            v-model="uploadStaffImage"
            accept="image/*"
            @change="onStaffFileChange"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
            </template>
          </v-file-input>
        </v-sheet>
        <v-btn text small color="grey darken-1" class="px-2" @click="clearStaffImage" v-if="hasStaffImage">이미지 초기화</v-btn>
      </div>

      <!-- 소개 문구 (다국어) -->
      <div class="mb-4">
        <div class="font-weight-medium mb-2">소개 문구</div>
        <v-textarea
          class="rounded-lg mb-2"
          label="소개 문구 (한글)"
          outlined
          auto-grow
          dense
          rows="3"
          hide-details
          v-model="introduction_kr"
          placeholder="작가 소개 문구를 입력해주세요."
        ></v-textarea>
        <v-textarea
          class="rounded-lg mb-2"
          label="소개 문구 (영어)"
          outlined
          auto-grow
          dense
          rows="3"
          hide-details
          v-model="introduction_en"
          placeholder="Enter staff introduction."
        ></v-textarea>
        <v-textarea
          class="rounded-lg"
          label="소개 문구 (일어)"
          outlined
          auto-grow
          dense
          rows="3"
          hide-details
          v-model="introduction_jp"
          placeholder="スタッフ紹介を入力してください。"
        ></v-textarea>
      </div>
    </v-sheet>

    <!-- 버튼 -->
    <div class="d-flex justify-center mt-8">
      <!-- 취소 -->
      <v-btn width="100" color="grey lighten-3" depressed class="font-weight-bold rounded-10 mr-3" @click="close()"> 닫기 </v-btn>

      <!-- 입력 -->
      <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="submit()"> 입력 </v-btn>
    </div>
  </v-sheet>
</template>
<script>
export default {
  data: () => ({
    select_list: {
      type: ["관리자", "메이커"],
      receiveTalk: ["Y", "N"],
    },

    type: "",
    name_kr: "",
    name_en: "",
    name_jp: "",
    user_id: "",
    password: "",
    phoneNumber: "",
    branchId: null,
    branchList: [],
    receiveTalk: "N",
    uploadImage: null,
    profileImage: "",
    profileImagePreview: "",
    uploadStaffImage: null,
    staffImage: "",
    staffImagePreview: "",
    introduction_kr: "",
    introduction_en: "",
    introduction_jp: "",
  }),

  mounted() {
    this.loadBranches()
  },

  beforeDestroy() {
    this.resetProfileImageState()
    this.resetStaffImageState()
  },

  computed: {
    profileImagePreviewSrc() {
      if (this.profileImagePreview) {
        return this.profileImagePreview
      }
      if (this.profileImage) {
        return this.buildProfileImageUrl(this.profileImage)
      }
      return "/upload/user/profile_image/default.png"
    },
    hasProfileImage() {
      return !!(this.profileImagePreview || (this.profileImage && this.profileImage !== "default.png"))
    },
    staffImagePreviewSrc() {
      if (this.staffImagePreview) {
        return this.staffImagePreview
      }
      if (this.staffImage) {
        return this.buildStaffImageUrl(this.staffImage)
      }
      return ""
    },
    hasStaffImage() {
      return !!(this.staffImagePreview || this.staffImage)
    },
  },

  methods: {
    async loadBranches() {
      try {
        const { data } = await this.$http.get("/api/admin/branch")
        this.branchList = (data?.branches || []).map((branch) => ({
          id: branch.id,
          displayText: `${branch.name} (${branch.branchCode})`,
        }))
      } catch (error) {
        console.error("branch load error", error)
      }
    },

    // 취소
    close() {
      // 값 초기화
      this.type = ""
      this.name_kr = ""
      this.name_en = ""
      this.name_jp = ""
      this.user_id = ""
      this.password = ""
      this.branchId = null
      this.introduction_kr = ""
      this.introduction_en = ""
      this.introduction_jp = ""
      this.resetProfileImageState()
      this.resetStaffImageState()

      this.$emit("close")
    },

    // 입력
    async submit() {
      if (this.type == "") {
        alert("직원 유형을 선택해주세요.")
      } else if (this.name_kr == "") {
        alert("이름(한글)을 입력해주세요.")
      } else if (this.user_id == "") {
        alert("아이디를 입력해주세요.")
      } else if (this.password == "") {
        alert("패스워드를 입력해주세요.")
      } else {
        const profileImage = await this.uploadProfileImageIfNeeded()
        const staffImage = await this.uploadStaffImageIfNeeded()

        // 이름 JSON 생성
        const namePayload = JSON.stringify({
          kr: this.name_kr || "",
          en: this.name_en || "",
          jp: this.name_jp || "",
        })

        // 소개 JSON 생성
        const hasIntroduction = this.introduction_kr || this.introduction_en || this.introduction_jp
        const introductionPayload = hasIntroduction
          ? JSON.stringify({
              kr: this.introduction_kr || "",
              en: this.introduction_en || "",
              jp: this.introduction_jp || "",
            })
          : null

        this.$http
          .post("/api/admin/staff/insert", {
            params: {
              type: this.type,
              name: namePayload,
              user_id: this.user_id,
              password: this.password,
              phoneNumber: this.phoneNumber ? this.phoneNumber : null,
              branchId: this.branchId || null,
              introduction: introductionPayload,
              ...(profileImage ? { profile_image: profileImage } : {}),
              ...(staffImage ? { profile_staff_image: staffImage } : {}),
            },
          })
          .then((res) => {
            if (res.data.affectedRows) {
              alert("직원이 정상적으로 입력되었습니다.")
              this.$emit("close")
              this.$emit("inserted")
              this.resetProfileImageState()
              this.resetStaffImageState()
            } else {
              alert("직원을 입력하는 도중 오류가 발생하였습니다.")
            }
          })
      }
    },

    buildProfileImageUrl(filename) {
      return filename && filename.includes("/") ? filename : `/upload/user/profile_image/${filename}`
    },

    buildStaffImageUrl(filename) {
      return filename && filename.includes("/") ? filename : `/upload/user/profile_image/${filename}`
    },

    onFileChange() {
      if (this.uploadImage instanceof File) {
        this.setUploadFile(this.uploadImage)
      } else {
        this.profileImagePreview = ""
      }
    },

    handleDrop(e) {
      const file = e?.dataTransfer?.files?.[0]
      if (file) {
        this.setUploadFile(file)
      }
    },

    setUploadFile(file) {
      if (!(file instanceof File)) {
        return
      }
      if (this.profileImagePreview) {
        URL.revokeObjectURL(this.profileImagePreview)
      }
      this.uploadImage = file
      this.profileImagePreview = URL.createObjectURL(file)
    },

    clearProfileImage() {
      this.resetProfileImageState()
    },

    resetProfileImageState() {
      if (this.profileImagePreview) {
        URL.revokeObjectURL(this.profileImagePreview)
      }
      this.uploadImage = null
      this.profileImagePreview = ""
      this.profileImage = ""
    },

    onStaffFileChange() {
      if (this.uploadStaffImage instanceof File) {
        this.setUploadStaffFile(this.uploadStaffImage)
      } else {
        this.staffImagePreview = ""
      }
    },

    handleStaffDrop(e) {
      const file = e?.dataTransfer?.files?.[0]
      if (file) {
        this.setUploadStaffFile(file)
      }
    },

    setUploadStaffFile(file) {
      if (!(file instanceof File)) {
        return
      }
      if (this.staffImagePreview) {
        URL.revokeObjectURL(this.staffImagePreview)
      }
      this.uploadStaffImage = file
      this.staffImagePreview = URL.createObjectURL(file)
    },

    clearStaffImage() {
      this.resetStaffImageState()
    },

    resetStaffImageState() {
      if (this.staffImagePreview) {
        URL.revokeObjectURL(this.staffImagePreview)
      }
      this.uploadStaffImage = null
      this.staffImagePreview = ""
      this.staffImage = ""
    },

    async uploadProfileImageIfNeeded() {
      if (!(this.uploadImage instanceof File)) {
        return this.profileImage
      }

      const formData = new FormData()
      formData.append("image", this.uploadImage)
      try {
        const { data } = await this.$http.post("/api/image/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            type: "profile_image",
          },
        })
        this.profileImage = data
        this.uploadImage = null
        return data
      } catch (error) {
        console.error("profile image upload error", error)
        alert("이미지 업로드 중 오류가 발생했습니다.")
        return ""
      }
    },

    async uploadStaffImageIfNeeded() {
      if (!(this.uploadStaffImage instanceof File)) {
        return this.staffImage
      }

      const formData = new FormData()
      formData.append("image", this.uploadStaffImage)
      try {
        const { data } = await this.$http.post("/api/image/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            type: "profile_image",
          },
        })
        this.staffImage = data
        this.uploadStaffImage = null
        return data
      } catch (error) {
        console.error("staff image upload error", error)
        alert("작가 소개 이미지 업로드 중 오류가 발생했습니다.")
        return ""
      }
    },
  },
}
</script>
<style scoped>
.test {
  width: 100%;
  border: 1px solid red;
}

.test tr td,
.test tr th {
  border: 1px solid red;
}
.profile-preview {
  height: 160px;
}

.staff-preview {
  height: 250px;
}

.preview-placeholder {
  width: 100%;
  text-align: center;
}

.profile-dropzone {
  border: 1px dashed #c4c4c4;
  border-radius: 10px;
  padding: 4px 8px;
}

.staff-dropzone {
  border: 1px dashed #c4c4c4;
  border-radius: 10px;
  padding: 4px 8px;
}
</style>
<style scoped>
.v-data-table >>> th,
.v-data-table >>> td {
  min-width: 200px !important;
}
</style>
